import { NgModule } from '@angular/core';
import { LicenseDetailsComponent } from './license-details.component';
import { Routes, RouterModule } from '@angular/router';
import { LicenseUsageComponent } from './license-usage/license-usage.component';

const routes: Routes = [
    {path: '',
    component: LicenseDetailsComponent} ,
    {path: 'licenseusage',
    component: LicenseUsageComponent},
];
@NgModule({
    imports: [
        RouterModule.forChild(routes)],
    exports: [RouterModule]

})
export class AccountLicenseRoutingModule {

}